<template>
  <div>
    <div :class="$forms.authLogo">
      <app-logo />
    </div>

    <div :class="$style.message">
      <p v-html="message" />

      <router-link :to="{ name: 'login' }">
        Sign In
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<style src="@/styles/forms.scss" lang="scss" module="$forms"></style>
<style lang="scss" module>

.message {
  padding: 50px;
  text-align: center;
}
</style>
